document.addEventListener('DOMContentLoaded', function () {


	// search overlay
	const searchBtn = document.getElementById('searchBtn');
	const searchOverlay = document.getElementById('searchOverlay');
	const closeSearchOverlay = document.getElementById('closeSearchOverlay');

	searchBtn.addEventListener('click', function () {
		searchOverlay.classList.remove('opacity-0', 'translate-y-full');
		searchOverlay.classList.add('opacity-100', 'translate-y-0');
	});

	closeSearchOverlay.addEventListener('click', function () {
		searchOverlay.classList.remove('opacity-100', 'translate-y-0');
		searchOverlay.classList.add('translate-y-full');
		setTimeout(function () {
			searchOverlay.classList.add('opacity-0');
		}, 500);
	});




	const direction = document.documentElement.getAttribute('dir');
  // *.*.*.*.*.*.*.*.*.*.* START OF video random *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  (function() {
    const titleBox = document.querySelector('.random_video .content');
    if (!titleBox) return;

    let isBoxVisible = false;

    setInterval(() => {
      titleBox.style.right = isBoxVisible ? '-100%' : '0';
      isBoxVisible = !isBoxVisible;
    }, 10000); // Toggle every 10 seconds
  })();

  // *.*.*.*.*.*.*.*.*.*.* END OF video random *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF AMP story carousel *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".ampstory_container")) {
    // carousel js just for desktop
    const isDesktop = window.matchMedia('(min-width: 769px)').matches;
    const carousel = document.querySelector('.ampstory');
    const prevButton = document.querySelector('.ampstory_carousel .prev');
    const nextButton = document.querySelector('.ampstory_carousel .next');

    if (isDesktop) {
      const itemWidth = carousel.querySelector('li').offsetWidth + parseInt(getComputedStyle(carousel).gap);
      let startX = 0,
        scrollLeft = 0,
        isDragging = false,
        isClick = true;

      const updateButtonState = () => {
        const maxScrollLeft = carousel.scrollWidth - carousel.offsetWidth;
        prevButton.disabled = Math.abs(carousel.scrollLeft) >= maxScrollLeft;
        nextButton.disabled = Math.abs(carousel.scrollLeft) === 0;
      };

      // Prevent default drag behavior on images and links
      carousel.querySelectorAll('img, a').forEach((el) => {
        el.addEventListener('mousedown', (e) => e.preventDefault());
      });

      // Scroll one item per button click
      prevButton.addEventListener('click', () => {
        carousel.scrollBy({
          left: -itemWidth,
          behavior: 'smooth'
        });
        setTimeout(updateButtonState, 300);
      });

      nextButton.addEventListener('click', () => {
        carousel.scrollBy({
          left: itemWidth,
          behavior: 'smooth'
        });
        setTimeout(updateButtonState, 300);
      });

      // Mouse drag functionality
      carousel.addEventListener('mousedown', (e) => {
        startX = e.pageX;
        scrollLeft = carousel.scrollLeft;
        isDragging = true;
        isClick = true; // Assume it's a click until movement is detected
        carousel.style.cursor = 'grabbing';
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const deltaX = e.pageX - startX;
        if (Math.abs(deltaX) > 5) isClick = false; // If mouse moves, it's a drag
        carousel.scrollLeft = scrollLeft - deltaX;
      });

      document.addEventListener('mouseup', () => {
        if (isDragging) {
          isDragging = false;
          carousel.style.cursor = 'grab';
          updateButtonState();
        }
      });

      // Prevent links from activating during drag
      carousel.addEventListener('click', (e) => {
        if (!isClick) e.preventDefault(); // Prevent click if it was a drag
      });

      carousel.addEventListener('mouseleave', () => {
        if (isDragging) {
          isDragging = false;
          carousel.style.cursor = 'grab';
          updateButtonState();
        }
      });

      carousel.addEventListener('scroll', updateButtonState);
      updateButtonState();
    } else {
      prevButton.style.display = 'none';
      nextButton.style.display = 'none';
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF AMP story carousel *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*



  // *.*.*.*.*.*.*.*.*.*.* Responsive table *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".ck_editor")) {
    var tables = document.querySelectorAll(".ck_editor table");
    tables.forEach(function (table) {
      var parentTable = document.createElement('div');
      parentTable.classList.add("table_res");
      document.querySelector(".ck_editor").replaceChild(parentTable, table);
      parentTable.appendChild(table);
    });
  }

  // *.*.*.*.*.*.*.*.*.*.* START OF tiny url *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".short_link")) {
    var shortLink = document.querySelector(".short_link");
    if (shortLink) {
      shortLink.addEventListener("click", function (event) {
        event.preventDefault();
        var temp = document.getElementById("short_link_copy");
        temp.select();
        document.execCommand("copy");
        document.querySelector(".copied").style.display = "block";
        setTimeout(function () {
          document.querySelector(".copied").style.display = "none";
        }, 1500);
      });
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF tiny url *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF TABs *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  function setupTabs(tabButtons, contentBoxes, container) {
    const tabs = Array.from(container.querySelectorAll(tabButtons));
    const contents = Array.from(container.querySelectorAll(contentBoxes));

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabs.forEach((tab, i) => {
          if (i === index) {
            tab.classList.add("active");
            contents[i].classList.add("visible");
          } else {
            tab.classList.remove("active");
            contents[i].classList.remove("visible");
          }
        });
      });
    });
  }

  // Setting up all the main tab containers
  document.querySelectorAll(".primary_multi_tab").forEach((container) => {
    setupTabs(".tabs_title li", ".tab_content", container);
    // container.querySelectorAll(".tab_content").forEach((tabContent) => {
    // setupTabs(".subtabs > div", ".subtab_content", tabContent);
    // });
  });
  // *.*.*.*.*.*.*.*.*.*.* END OF TABs *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*


  // *.*.*.*.*.*.*.*.*.*.* START OF main menu *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // Main menu toggle
  const mainMenu = document.querySelector(".top_nav");
  const menuToggleButton = document.querySelector(".menu_btn_cnt");

  if (mainMenu && menuToggleButton) {
    menuToggleButton.addEventListener('click', () => {
      setTimeout(() => {
        mainMenu.classList.toggle('slide_down');
        menuToggleButton.classList.toggle('close_open');
      }, 10);
    });
  }

  // ----- SUB_MENU -----
  document.querySelectorAll('.sub_menu_btn').forEach(subMenuButton => {
    subMenuButton.addEventListener('click', () => {
      setTimeout(() => {
        const subMenu = subMenuButton.nextElementSibling;
        if (subMenu) {
          subMenu.classList.toggle('slide_down');
        }
      }, 10);
    });
  });
  // ----- END OF SUB_MENU -----

  // *.*.*.*.*.*.*.*.*.*.* END OF main menu *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // ---- START OF COMMENT NEWS AJAX ----
	if (document.getElementById('comment_list_ajax')) {
		const commentList = document.getElementById('comment_list_ajax');
		const loadMoreBtn = document.getElementById('load_more_comment');
		let currentPage = 1;
		// Initialize limit comment number
		const limitPage = 5;

		if (news_comment < limitPage) loadMoreBtn.remove();

		const loadMoreComments = () => {
			fetch(
				`/comments/ajaxCommentList?newsId=${news_id}&page=${currentPage}&limit=${limitPage}`
			)
				.then((response) => response.json())
				.then((data) => {
					if (!data || data.length < limitPage)
						loadMoreBtn.style.display = 'none';
					if (data) {
						data.forEach((comment) => {
							const renderChildren = (children) =>
								children
									? `<ul>${children
											.map(
												(child) => `
					<li class="w-full">
						<div class="w-full">
							<div class="flex gap-3 items-center space-x-2 rtl:space-x-reverse w-full">
								<div class="flex space-x-2 items-center gap-5">
									<span>
										<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 16 16"><g fill="#000"><path d="M11 6a3 3 0 1 1-6 0a3 3 0 0 1 6 0"/><path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/></g></svg>
									</span>
									<span class="font-bold text-sm lg:text-base text-gray-600">
										${child.name || window.i18n.commentUnknown}
									</span>
								</div>
								<span class=" text-xs sm:text-sm font-semibold flex-1">
									<time datetime="${child.creation}">
										${child.date}
									</time><
								/span>
							</div>
							<div class="mt-4 text-sm sm:text-base  tracking-wide">
								<p>${child.message}</p>
							</div>
						</div>
						<div class="mt-4 flex lg:hidden space-x-4 rtl:space-x-reverse justify-between items-center">
							<div class="flex lg:flex-col justify-between items-center w-20 h-8 lg:h-20 lg:w-8 bg-gray-200 dark:bg-slate-900 rounded-md">
								<button class="lg:w-full lg:h-auto h-full flex justify-center items-center p-2">
									<svg xmlns="http://www.w3.org/2000/svg" class="text-gray-600" width="11" height="11" fill="currentColor">
										<path d="M6.33 10.896c.137 0 .255-.05.354-.149.1-.1.149-.217.149-.354V7.004h3.315c.136 0 .254-.05.354-.149.099-.1.148-.217.148-.354V5.272a.483.483 0 0 0-.148-.354.483.483 0 0 0-.354-.149H6.833V1.4a.483.483 0 0 0-.149-.354.483.483 0 0 0-.354-.149H4.915a.483.483 0 0 0-.354.149c-.1.1-.149.217-.149.354v3.37H1.08a.483.483 0 0 0-.354.15c-.1.099-.149.217-.149.353v1.23c0 .136.05.254.149.353.1.1.217.149.354.149h3.333v3.39c0 .136.05.254.15.353.098.1.216.149.353.149H6.33Z" fill="currentColor" />
									</svg>
								</button>
								<span class="font-semibold text-indigo-600 dark:text-indigo-300" id="ratescore${child.master_id}">
									${child.score || 0}
								</span>
								<button class="lg:w-full lg:h-auto h-full flex justify-center items-center p-3">
									<svg xmlns="http://www.w3.org/2000/svg" class="text-gray-600" width="11" height="3" fill="currentColor">
										<path d="M9.256 2.66c.204 0 .38-.056.53-.167.148-.11.222-.243.222-.396V.722c0-.152-.074-.284-.223-.395a.859.859 0 0 0-.53-.167H.76a.859.859 0 0 0-.53.167C.083.437.009.57.009.722v1.375c0 .153.074.285.223.396a.859.859 0 0 0 .53.167h8.495Z" fill="currentColor" />
									</svg>
								</button>
							</div>
							<div class="flex items-center space-x-4 rtl:space-x-reverse cursor-pointer">
								<div class="flex items-center space-x-1 rtl:space-x-reverse">
									<span class="text-indigo-500 font-semibold text-sm" aria-label="replay" onclick="setCommentParentId(${child.id})">
										${window.i18n.commentReply}
									</span>
								</div>
							</div>
						</div>
					</div>
					</li>`
											)
											.join('')}</ul>`
									: '';

								
							commentList.innerHTML += `
					<li class="w-full">
						<div class="text-gray-700  leading-8 transition p-4 md:p-6 lg:p-8 lg:flex lg:space-x-4 rtl:lg:space-x-reverse w-full">
							<div class="w-full ">
								<div class="bg-[#b5b5b5] p-3 flex gap-8 items-center space-x-2 rtl:space-x-reverse w-full  ">
									<div class="flex space-x-2 items-center gap-2">
										<span>
											<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 16 16"><g fill="#000"><path d="M11 6a3 3 0 1 1-6 0a3 3 0 0 1 6 0"/><path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/></g></svg>
										</span>
										<span class="font-bold text-sm lg:text-base text-gray-600">
											${comment.name || window.i18n.commentUnknown}
										</span>
									</div>
									<span class="text-gray-400 text-xs sm:text-sm font-semibold flex-1">
										<time datetime="${comment.creation}">
											${comment.date}
										</time>
									</span>
									<div class=" lg:block">
										<div class="flex items-center space-x-4 rtl:space-x-reverse cursor-pointer">
											<div class="flex items-center space-x-1 rtl:space-x-reverse">
												<span class="text-indigo-500 font-semibold text-sm" aria-label="replay" onclick="setCommentParentId(${comment.id})">
													${window.i18n.commentReply}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div class="bg-zinc-100 p-3 text-sm sm:text-base text-gray-800 bg-[e4e4e7] tracking-wide ">
									<p>${comment.message}</p>
								</div>
							</div>
							<div class="hidden mt-4 lg:hidden space-x-4 rtl:space-x-reverse justify-between items-center">
								<div class="flex lg:flex-col justify-between items-center w-20 h-8 lg:h-20 lg:w-8 bg-gray-200 dark:bg-slate-900 rounded-md">
									<button class="lg:w-full lg:h-auto h-full flex justify-center items-center p-2">
										<svg xmlns="http://www.w3.org/2000/svg" class="text-gray-700 dark:text-gray-300 transition" width="11" height="11" fill="currentColor">
											<path d="M6.33 10.896c.137 0 .255-.05.354-.149.1-.1.149-.217.149-.354V7.004h3.315c.136 0 .254-.05.354-.149.099-.1.148-.217.148-.354V5.272a.483.483 0 0 0-.148-.354.483.483 0 0 0-.354-.149H6.833V1.4a.483.483 0 0 0-.149-.354.483.483 0 0 0-.354-.149H4.915a.483.483 0 0 0-.354.149c-.1.1-.149.217-.149.354v3.37H1.08a.483.483 0 0 0-.354.15c-.1.099-.149.217-.149.353v1.23c0 .136.05.254.149.353.1.1.217.149.354.149h3.333v3.39c0 .136.05.254.15.353.098.1.216.149.353.149H6.33Z" fill="currentColor" />
										</svg>
									</button>
									<span class="font-semibold text-indigo-600 dark:text-indigo-300" id="ratescore${comment.master_id}">
										${comment.score || 0}
									</span>
									<button class="lg:w-full lg:h-auto h-full flex justify-center items-center p-3">
										<svg xmlns="http://www.w3.org/2000/svg" class="text-gray-700 dark:text-gray-300 transition" width="11" height="3" fill="currentColor">
											<path d="M9.256 2.66c.204 0 .38-.056.53-.167.148-.11.222-.243.222-.396V.722c0-.152-.074-.284-.223-.395a.859.859 0 0 0-.53-.167H.76a.859.859 0 0 0-.53.167C.083.437.009.57.009.722v1.375c0 .153.074.285.223.396a.859.859 0 0 0 .53.167h8.495Z" fill="currentColor" />
										</svg>
									</button>
								</div>
								<div class="flex items-center space-x-4 rtl:space-x-reverse cursor-pointer">
									<div class="flex items-center space-x-1 rtl:space-x-reverse">
										<span class="text-indigo-500 font-semibold text-sm" aria-label="replay" onclick="setCommentParentId(${comment.id})">
											${window.i18n.commentReply}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div class="space-y-4 mt-5 rtl:lg:mr-10 ltr:lg:ml-10 rtl:pl-3 ltr:pr-3 rtl:lg:pr-8 ltr:lg:pl-8 rtl:border-r-2 ltr:border-r-2 rtl:lg:border-r-4 ltr:lg:border-l-4 border-gray-200 dark:border-gray-800 rounded">
							${
								comment.children === null || comment.children.length === 0
									? ''
									: renderChildren(comment.children)
							}
						</div>
					</li>
					`;
						});
						currentPage++;
					}
				})
				.catch((error) => console.error(error));
		};

		loadMoreComments();
		loadMoreBtn.addEventListener('click', loadMoreComments);
	}
  // ---- END OF COMMENT NEWS AJAX ----


 


  
	// *.*.*.*.*.*.*.*.*.*.* START OF light Gallery *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
	if (document.querySelectorAll('.album_list')) {
		var gallery = document.querySelectorAll('.album_list');
		gallery.forEach(function (pic) {
			lightGallery(pic, {
				speed: 500,
				plugins: [lgThumbnail],
				thumbnail: true,
			});
		});
	}
	// *.*.*.*.*.*.*.*.*.*.* END OF light Gallery *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*



	// hamburger menu
	const hamburgerBtn = document.getElementById('hamburgerBtn');
	const mobileMenu = document.getElementById('mobileMenu');
	const closeMenu = document.getElementById('closeMenu');

	hamburgerBtn.addEventListener('click', function () {
		mobileMenu.classList.remove('translate-x-full');
		mobileMenu.classList.add('translate-x-0');
	});

	closeMenu.addEventListener('click', function () {
		mobileMenu.classList.remove('translate-x-0');
		mobileMenu.classList.add('translate-x-full');
	});

	// mobile menu dropdown
	const dropdownToggle = document.querySelectorAll('.dropdown-toggle');
	for (let i = 0; i < dropdownToggle.length; i++) {
		const toggle = dropdownToggle[i];
		const svgIcon = toggle.nextElementSibling;

		svgIcon.addEventListener('click', function (event) {
			event.preventDefault();
			toggle.checked = !toggle.checked;
			document
				.querySelector(`.dropdown-${toggle.value}`)
				.classList.toggle('hidden', !toggle.checked);
			svgIcon
				.querySelector('svg')
				.classList.toggle('rotate-180', toggle.checked);
		});
	}



  // splide thumbnail

	if (document.getElementById('sliderLB')) {
		var splide = new Splide('#sliderLB', {
			autoplay: false,
			interval: 5000,
			pauseOnHover: true,
			pagination: false,
			arrows: false,
			direction: direction,
			gap: '1rem',
		});

		var thumbnails = document.getElementsByClassName('thumbnail');
		var current;

		for (var i = 0; i < thumbnails.length; i++) {
			initThumbnail(thumbnails[i], i);
		}

		function initThumbnail(thumbnail, index) {
			thumbnail.addEventListener('click', function () {
				splide.go(index);
			});
		}

		splide.on('mounted move', function () {
			var thumbnail = thumbnails[splide.index];

			if (thumbnail) {
				// حذف کلاس 'active' از تصویر قبلی
				if (current) {
					current.classList.remove('active', '!border-white');
				}

				// افزودن کلاس 'active' به تصویر فعلی
				thumbnail.classList.add('active', '!border-white');
				current = thumbnail;
			}
		});

		splide.mount();
	}


	// ----- INLINE ADV -----
	var countP = document.querySelectorAll('#article_body p:not(table p, blockquote p)');
	function insertBefore(newNode, dist) {
		dist.parentNode.insertBefore(newNode, dist)
	}
	// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*- //
	if (document.getElementById('inline_adv')) {
		if (countP.length > 0) {
		var adv = document.getElementById('inline_adv');
		insertBefore(adv, countP[3].nextSibling);
		} else {
		document.getElementById('inline_adv').style.display = "none";
		}
	}
	//---------- END OF INLINE ADV ----------
})
